<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Gröda'" :sub-title="crop_name" :title-id="crop_id"></limitless-page-header>

        <div class="content">
            <div v-if="busy_loading">
                <i class="icon-spinner2 spinner"></i>
            </div>
            <div v-else-if="crop">
                <ValidationObserver ref="cropform">
                    <form @submit.prevent="saveCrop">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="card">
                                    <div class="card-header bg-white">
                                        <h5 class="card-title">Gröda</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Namn: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="name" name="Namn" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="crop.name" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Kod: <span class="text-danger">*</span></label>
                                            <div class="col-lg-5">
                                                <ValidationProvider vid="code" name="Kod" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="crop.code" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Dagar i groskåp: <span class="text-danger">*</span></label>
                                            <div class="col-lg-5">
                                                <ValidationProvider vid="germination_days" name="Dagar" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="number" min="0" step="1" class="form-control" v-model="crop.germination_days" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Dagar i barnkammare: <span class="text-danger">*</span></label>
                                            <div class="col-lg-5">
                                                <ValidationProvider vid="nursery_days" name="Dagar" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="number" min="0" step="1" class="form-control" v-model="crop.nursery_days" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Dagar i systemet: <span class="text-danger">*</span></label>
                                            <div class="col-lg-5">
                                                <ValidationProvider vid="system_days" name="Dagar" rules="required" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="number" min="0" step="1" class="form-control" v-model="crop.system_days" v-bind:class="{ 'border-danger':errors[0] }" disabled>
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Såinstruktion:</label>
                                            <div class="col-lg-10">
                                                <ValidationProvider vid="instructions" name="Instruktion" rules="" v-slot="{ errors }">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" v-model="crop.instructions" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-footer">
                                        <div class="d-flex justify-content-between">
                                            <limitless-button ref="btndeletecrop" type="button" @click="deleteCrop" :busy="busy_saving" icon="icon-cross2" btn-class="btn-danger">Radera</limitless-button>
                                            <limitless-button ref="btnsavecrop" type="button" @click="saveCrop" :busy="busy_saving" icon="icon-floppy-disk">Spara</limitless-button>
                                        </div>
                                    </div>
                                </div> <!-- /card -->
                            </div> <!-- /col -->
                            <div class="col-lg-6">
                            </div>
                        </div> <!-- /row -->
                    </form>
                </ValidationObserver>
            </div>
            <div v-else>
                <i class="text-danger">Kunde inte ladda data</i>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Limitless/LimitlessPageHeader';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import { getError } from '@services/Helpers';

export default {
    name: 'CropEdit',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
    },
    props: {
        id: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        crop: null,
    }),
    mounted() {
        this.getCrop();
    },
    methods: {
        getCrop() {
            this.busy_loading = true;
            apiClient.get('/vue/crops/' + this.id + '')
                .then((response) => {
                    this.crop = response.data;
                    this.crop.system_days = 14;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveCrop() {
            const isValid = await this.$refs.cropform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/crops/' + this.id + '', this.crop)
                    .then((response) => {
                        if (this.id !== response.data.id) {
                            window.location.href = '/crops/' + response.data.id;
                        }
                        this.crop = response.data;
                        this.$refs.btnsavecrop.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.cropform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecrop.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        deleteCrop() {
            // eslint-disable-next-line no-restricted-globals, no-alert
            if (confirm('Är du säker på att du vill radera denna gröda?')) {
                this.busy_saving = true;
                apiClient.delete('/vue/crops/' + this.id)
                    .then(() => {
                        document.location.href = '/crops';
                        this.busy_saving = false;
                    })
                    .catch(() => {
                        this.$refs.btndeletecrop.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
    watch: {

    },
    computed: {
        crop_name() {
            return (this.crop && this.crop.id > 0 ? this.crop.name : 'Ny gröda');
        },
        crop_id() {
            return (this.crop && this.crop.id > 0 ? this.crop.id : '');
        },
    },
};
</script>
